import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import { Button, Input, Text } from '../../../../components';
import type { TierBlockProps } from './types';
import { DeleteOutline } from '@mui/icons-material';

export const TierBlock: React.FC<TierBlockProps> = ({
  tierKey,
  strings,
  disabled,
  onChange,
}) => {
  const updateString = (index: number, value: string) => {
    const updated = [...strings];
    updated[index] = value;
    onChange(updated);
  };

  const addString = () => onChange([...strings, '']);

  const removeString = (index: number) => {
    onChange(strings.filter((_, i) => i !== index));
  };

  return (
    <div className="flex flex-col gap-2">
      <Text
        as="span"
        variant="secondary"
        className="text-small font-semibold uppercase tracking-wide"
      >
        {tierKey.replace('_', ' ')}
      </Text>

      {strings.map((str, i) => (
        <div key={i} className="flex items-stretch gap-2">
          <div className="flex-1">
            <Input
              value={str}
              disabled={disabled}
              placeholder="e.g. \bplease leave.*message\b"
              onChange={val => updateString(i, val)}
            />
          </div>
          {!disabled && (
            <Button
              type="contrast"
              size="empty"
              tooltip="Remove pattern"
              icon={<DeleteOutline fontSize="small" color="error" />}
              onClick={() => removeString(i)}
              className="px-3"
            />
          )}
        </div>
      ))}

      {!disabled && (
        <Button
          type="outline"
          size="small"
          label="Add pattern"
          icon={<AddIcon />}
          onClick={addString}
        />
      )}
    </div>
  );
};
